'use client'
import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import { useState } from 'react';
import ServiceDetailsImg from '../../assets/images/services/MAGNET.png'
import ServiceDetailsImg1 from '../../assets/images/services/container-shear-12.png'
import ServiceDetailsImg2 from '../../assets/images/services/service-details-images-1-2.jpg'
import ImageGallery from "react-image-gallery";
import 'react-image-gallery/styles/css/image-gallery.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import table, { Table } from 'react-bootstrap'
import SEOHelmet from '../../components/SEO/SEOHelmet';
import VideoOne from '../home-3/VideoOne';
// import ModalVideo from 'react-modal-video';
// import 'react-modal-video/css/modal-video.min.css';
const mainSlider = {
    width: '90%',
}
const HorizontalShear = () => {
    const images = [
        {
            original: ServiceDetailsImg1,
            thumbnail: ServiceDetailsImg1,
            originalAlt: "Slide 1",
            thumbnailAlt: "Thumbnail 1",
        },
        // { 410X361px
        //     original: ServiceDetailsImg2,
        //     thumbnail: ServiceDetailsImg2,
        //     originalAlt: "Slide 2",
        //     thumbnailAlt: "Thumbnail 2",
        // }

    ]
    // State to hold dynamic content
    const [projectInfo] = useState({
        category: "Roof Service",
        customer: "David Bravis",
        startDate: "21 April 2024",
        endDate: "28 September 2024",
        rating: 5,
    });
    const [socialLinks] = useState([
        { href: "https://www.facebook.com/profile.php?id=61573443062800", iconClass: "icon-facebook-f" },
        { href: "https://x.com/design79356", iconClass: "icon-Vector" },
        { href: "https://www.instagram.com/ramanasteels/", iconClass: "icon-instagram" },
        { href: "https://in.pinterest.com/Ramanasteels/", iconClass: "icon-pinterest" },
    ]);
    const [serviceDetails] = useState({


        image1: ServiceDetailsImg,

        title: "Horizontal Automatic Container Shearing Machine",
        text2: "The Horizontal Automatic Container Shearing machine is specially designed for efficiently cutting metal shaped in various cross sections such as round, square, channel, angle, I-beam, plates, and other waste structural metals in cold state. It significantly simplifies the process of baling, storage, and transportation of scrap metal, while also providing high-quality furnace charges for smelting plants.With the introduction of this upgraded machine, you can now expect: Improved cutting quality Enhanced blade performance and durability Better overall machine efficiency and reliability Advanced design for higher productivity This is not just any ordinary shear – this is the best machine in its category, engineered for consistent performance.Others can’t even offer a stable price for their machine or spare parts — with us, you get reliability, consistency, and premium quality.",
        points: [
            "Our machines are ingrained with hydraulic drive, and you can choose between a manual or a PLC-automatic control operation",
            "Supports AC Cooling/ Water Cooling",
            "Cutting range is 2mm - 4” and varies from model to model",
            "You can operate it from a remote control, which means you save on labor cost, transportation cost, space, and stock cost.",

        ],

    });

    return (

        <React.Fragment>
            <SEOHelmet 
                title="Horizontal Automatic Container Shear Machine"
                description="Automatic container shearing machine for cutting metal in various shapes. Remote control operation saves labor and storage costs. Hydraulic drive with manual or PLC control."
                keywords="horizontal shear, container shear, automatic shearing machine, metal cutting, container processing"
                canonicalUrl="https://ramanasteels.com/horizontal-automatic-container-shear"
            />
            {/* Service Details Start */}
            <section className="service-details">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="service-details__left">
                                <div className="service-details__content-one">

                                    <p className="service-details__text-1">{serviceDetails.text1}</p>
                                    <div className="justify-content-center mt-4">
                                        <div className="card p-3 rounded" style={mainSlider}>
                                            <ImageGallery
                                                items={images}
                                                showPlayButton={false}
                                                showFullscreenButton={true}
                                                showThumbnails={true}
                                                autoPlay={true}
                                                slideInterval={4000}
                                                showNav={true}
                                                additionalClass="img-slider"
                                            />
                                        </div>
                                    </div>
                                    <h1 className="service-details__title-one">{serviceDetails.title}</h1>
                                </div>

                                <div className="service-details__content-two">
                                    <h4 className="service-details__title-two">{serviceDetails.title2}</h4>
                                    <p className="service-details__text-2">{serviceDetails.text2}</p>
                                    {/* <div><VideoOne videoId={"nGORoPFurpM"} /></div> */}
                                    <VideoOne videoId={"nGORoPFurpM"} />
                                    <ul className="list-unstyled service-details__points">
                                        <h3>Features</h3>
                                        {serviceDetails.points.map((point, index) => (
                                            <li key={index}>
                                                <div className="icon">
                                                    <i className="far fa-check" />
                                                </div>
                                                <div className="text">
                                                    <p>{point}</p>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div>
                                    <Table responsive>
                                        <thead style={{ color: '#FFFFFF', background: '#2F8CD6' }}><tr> <th>Model   </th>
                                            <th>Press Box Width(mm) </th>
                                            <th>Cut Piece length(mm)</th>
                                            <th>Capacity(T/H) </th>
                                            <th>Cutting Force(KN)</th>
                                            <th>Power</th>
                                        </tr></thead>
                                        <tbody>
                                            <tr>
                                                <td>CS-630</td>
                                                <td>1400/1600</td>
                                                <td>400</td>
                                                <td>9-14</td>
                                                <td>6300</td>
                                                <td>55kw*2</td>
                                            </tr>
                                            <tr>
                                                <td>CS-800</td>
                                                <td>1600</td>
                                                <td>400</td>
                                                <td>15-22</td>
                                                <td>8000</td>
                                                <td>55kw*3</td>
                                            </tr>
                                            <tr>
                                                <td>CS-1000</td>
                                                <td>1600</td>
                                                <td>400</td>
                                                <td>23-25</td>
                                                <td>10000</td>
                                                <td>55kw*4</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5">
                            <div className="project-details__sidebar">
                                <div className="project-details__project-info">
                                    <h3 className="project-details__project-info-title">
                                        Product Information
                                    </h3>
                                    <ul className="list-unstyled project-details__project-info-list">
                                        <li>
                                            <h5>Origin:</h5>
                                            <h5>China{/* {projectInfo.category} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Make:</h5>
                                            <h5>Gaode{/* {projectInfo.customer} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Used In:</h5>
                                            <h5> Heavy duty scrap<br /> processing{/* {projectInfo.startDate} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Rating:</h5>
                                            <div className="rating">
                                                {Array(projectInfo.rating)
                                                    .fill(0)
                                                    .map((_, index) => (
                                                        <span className="icon-star" key={index}></span>
                                                    ))}
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="project-details__social">
                                        {socialLinks.map((link, index) => (
                                            <Link to={link.href} key={index}>
                                                <span className={link.iconClass}></span>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="project-details__need-help">
                                {/* <div className="project-details__need-help-img">
                                    <img
                                        src="/assets/images/project/project-details-need-help-img.jpg"
                                        alt="Need Help"
                                    />
                                </div> */}
                                <div className="project-details__need-help-icon">
                                    <span className="icon-call"></span>
                                </div>
                                <p className="project-details__need-help-sub-title">
                                    Contact Us
                                </p>
                                <h3 className="project-details__need-help-number">
                                    <Link to="tel:+91-9815902561"> +91-9815902561</Link>
                                </h3>
                            </div>
                            {/* <div className="project-details__download">
                                <ul className="project-details__download-list list-unstyled">
                                    <li>
                                        <Link to="#">
                                            <span>Company File</span>
                                            <p>
                                                (1.5Mb)
                                                <i className="icon-download"></i>
                                            </p>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <span>Project File</span>
                                            <p>
                                                (1.5Mb)
                                                <i className="icon-download"></i>
                                            </p>
                                        </Link>
                                    </li>
                                </ul>
                            </div> */}
                        </div>

                    </div>
                </div>
            </section>
            {/* Service Details End */}
        </React.Fragment>
    );
};

export default HorizontalShear;
